import React, { FC, useContext } from 'react';
import { WithStyle } from '../../utils/with-style';
import { ModalFooterStyled } from './modal.styled';
import ModalContext from './modal-context';

const ModalFooter: FC & WithStyle = props => {
  const contextProps = useContext(ModalContext);
  return (
    <ModalFooterStyled {...contextProps} {...props}>
      {React.Children.map(props.children, content => content)}
    </ModalFooterStyled>
  );
};

export default ModalFooter;
